/*
 * @format
 */
import React from 'react';
import { isEmpty, uniqueId } from 'lodash';
import { PropTypes } from 'prop-types';
import Notification from '../../sharedComponents/Notification';

export default class ErrorNotification extends React.PureComponent {
    static propTypes = {
        errorHeader: PropTypes.string,
        errors: PropTypes.arrayOf(PropTypes.string),
        className: PropTypes.string,
        innerRef: PropTypes.shape({
            current: PropTypes.instanceOf(Element)
        })
    }

    static defaultProps = {
        errorHeader: "Errors:",
        className: "mb-4"
    }

    render() {
        const { errorHeader, errors, className, innerRef } = this.props;

        return (
        <div tabIndex="-1" className="rec-error-notification" ref={innerRef}>
            {!isEmpty(errors) &&
                <Notification className={className} type="error" title={errorHeader} key={uniqueId()}>
                    {/* adding new key to Notification to force update so it reads out everything on voiceover */}
                    <ul>
                        {errors.filter((err) => err).map((err) => (
                            <li key={uniqueId()}>
                                <div className="permit-validation">
                                    {err}
                                </div>
                            </li>
                        ))}
                    </ul>
                </Notification>
            }
        </div>
        );
    }
}
